import { createContext, Dispatch, SetStateAction } from 'react';
import { AxiosError } from 'axios';
import { FetchState } from '../hooks/useFetchState';
import { IAlert } from '../models/common';
import {
  IOrderDetailsRequestParams,
  IOrderDetailsResponse,
} from '../models/order-details';
import { ISORISOrderNumberBarcodeResponse } from '../models/soris';

export interface IOrderDetailsContext {
  alertState: IAlert | null;
  exportAlertState: IAlert | null;
  localDelivery: boolean;
  nickName: string;
  orderBarcodeApiState?: FetchState<ISORISOrderNumberBarcodeResponse>;
  orderDetailsData?: IOrderDetailsResponse | undefined;
  orderDetailsError?: AxiosError | undefined;
  orderDetailsLoaded?: boolean;
  orderDetailsRequestParams: IOrderDetailsRequestParams;
  orderIndex: number;
  deliveryTrackerLoaded: boolean;
  orderNumber: string;
  setAlertState: Dispatch<SetStateAction<IAlert | null>>;
  setExportAlertState: Dispatch<SetStateAction<IAlert | null>>;
}

const defaultState: IOrderDetailsContext = {
  alertState: null,
  exportAlertState: null,
  localDelivery: false,
  nickName: '',
  orderDetailsData: undefined,
  orderDetailsError: undefined,
  orderDetailsLoaded: false,
  orderDetailsRequestParams: {
    customerAccountId: '',
    orderDetailsRoute: '',
    orderIndex: 0,
    orderNumber: '',
    registerNumber: 0,
    salesDate: '',
    storeNumber: 0,
    transactionId: 0,
    timezone: '',
  },
  orderIndex: 0,
  deliveryTrackerLoaded: false,
  orderNumber: '',
  setAlertState: () => null,
  setExportAlertState: () => null,
};

/**
 * OrderDetailsContext is defined in its own module to guarantee a single
 * createContext() call across all Rollup/Vite production chunks.
 *
 * If this module were co-located with OrderDetailsProvider, code-splitting
 * could cause it to appear in both the main chunk (App.tsx static import) and
 * the dynamic OrderDetails page chunk, creating two separate context instances.
 * That would make useOrderDetailsContext() return defaultState even when the
 * provider has populated data — a bug that only manifests in production builds.
 */
export const OrderDetailsContext =
  createContext<IOrderDetailsContext>(defaultState);
